import { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

export interface IpInfoData {
  ip: string;
  city?: string;
  region?: string;
  country?: string;
  org?: string;
  timezone?: string;
  postal?: string;
  loc?: string;
  hostname?: string;
  isShopWifi: boolean;
}

interface IpInfoProps {
  info: IpInfoData;
}

const IpInfo = ({ info }: IpInfoProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="mt-4 border border-gray-200 rounded-lg overflow-hidden">
      <div 
        className="bg-gray-50 p-2 sm:p-3 border-b border-gray-200 font-medium flex items-center justify-between cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span>IP Address Information</span>
        <ChevronDownIcon 
          className={`w-5 h-5 transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`} 
        />
      </div>
      <div className={`p-2 sm:p-3 bg-gray-50 ${isExpanded ? '' : 'hidden'}`}>
        <div className="ip-info-row flex flex-col sm:flex-row sm:justify-between py-2 border-b border-gray-100">
          <div className="ip-info-label text-gray-500 font-medium">IP Address:</div>
          <div className="ip-info-value break-all">{info.ip || 'Unknown'}</div>
        </div>

        {(info.city || info.region) && (
          <div className="ip-info-row flex flex-col sm:flex-row sm:justify-between py-2 border-b border-gray-100">
            <div className="ip-info-label text-gray-500 font-medium">Location:</div>
            <div className="ip-info-value break-all">
              {info.city || ''} {info.region ? (info.city ? ', ' + info.region : info.region) : ''}
            </div>
          </div>
        )}

        {info.country && (
          <div className="ip-info-row flex flex-col sm:flex-row sm:justify-between py-2 border-b border-gray-100">
            <div className="ip-info-label text-gray-500 font-medium">Country:</div>
            <div className="ip-info-value break-all">{info.country}</div>
          </div>
        )}

        {info.org && (
          <div className="ip-info-row flex flex-col sm:flex-row sm:justify-between py-2 border-b border-gray-100">
            <div className="ip-info-label text-gray-500 font-medium">ISP:</div>
            <div className={`ip-info-value break-all ${!info.isShopWifi ? 'text-amber-600' : ''}`}>
              {info.org} {!info.isShopWifi ? ' (Not shop WiFi)' : ''}
            </div>
          </div>
        )}

        {info.timezone && (
          <div className="ip-info-row flex flex-col sm:flex-row sm:justify-between py-2 border-b border-gray-100">
            <div className="ip-info-label text-gray-500 font-medium">Timezone:</div>
            <div className="ip-info-value break-all">{info.timezone}</div>
          </div>
        )}

        {info.postal && (
          <div className="ip-info-row flex flex-col sm:flex-row sm:justify-between py-2 border-b border-gray-100">
            <div className="ip-info-label text-gray-500 font-medium">Postal Code:</div>
            <div className="ip-info-value break-all">{info.postal}</div>
          </div>
        )}

        {info.loc && (
          <div className="ip-info-row flex flex-col sm:flex-row sm:justify-between py-2 border-b border-gray-100">
            <div className="ip-info-label text-gray-500 font-medium">Coordinates:</div>
            <div className="ip-info-value break-all">{info.loc}</div>
          </div>
        )}

        {info.hostname && (
          <div className="ip-info-row flex flex-col sm:flex-row sm:justify-between py-2 border-b border-gray-100 last:border-0">
            <div className="ip-info-label text-gray-500 font-medium">Hostname:</div>
            <div className="ip-info-value break-all">{info.hostname}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default IpInfo; 